module.exports = __webpack_public_path__ + "img/point-2@2x.3fc8bc5d.jpg";